const entitesColumns = {
  name: true,
  subdomain: true,
  kiosk: true,
  package: true,
};
const dashboardColumns = {
  Image: true,
  Status: true,
  FirstName: true,
  LastName: true,
  UserType: true,
  Area: true,
  Site: true,
  InputType: true,
  Temperature: true,
  hasMask: true,
  Arrival: true,
  Compliances: true,
  VaccineDocument: true,
};
const usersColumns = {
  ID: true,
  Image: true,
  FirstName: true,
  LastName: true,
  Status: true,
  UserType: true,
  CompanyName: true,
  Email: true,
  PhoneNumber: true,
  VisiPointPassport : true,
  VehicleRegistration: true,
  RFID:true,
  SystemUser: true,
  VaccineDocument: true,
};
const userTypesColumns = {
  Name: true,
  RegistrationMethod: true,
  GracePeriod: true,
};
const privacyManagerColumns = {
  UserType: true,
  DataRetention: true,
  ScansRetention: true,
  DeleteRecordsUpTo: true,
};
const complianceColumns = {
  name: true,
  version: true,
  date: true,
};
const reportHistoryColumns = {
  Image: true,
  Status: true,
  FirstName: true,
  LastName: true,
  UserType: true,
  ID: true,
  Kiosk: true,
  Area: true,
  Site: true,
  InputType: true,
  hasMask: true,
  Temperature: true,
  Date: true,
  VaccineDocument: true,
  Compliances: true,
};
const reportTimeColumns = {
  Image: true,
  FirstName: true,
  LastName: true,
  UserType: true,
  Kiosk: true,
  InputType: true,
  Temperature: true,
  CheckIN: true,
};
const trackTraceColumns = {
  FirstName: true,
  LastName: true,
  UserType: true,
  InputType: true,
  Kiosk: true,
  Date: true,
};
const tracAndTraceColumns = {
  firstName: true,
  lastName: true,
  userType: true,
  inputType: true,
  device: true,
  sites: true,
  areas: true,
  date: true,
};

const importUsersColumns = {
  Image: true,
  Name: true,
  UserType: true,
  ID: true,
  RFID: true,
  Email: true,
  PhoneNumber: true,
  Status: true,
  Comments: true,
};
const importQueuesColumns = {
  Operator: true,
  Serial: true,
  Date: true,
  ID: true,
  Time: true,
  Status: true,
};
const importUsersDetailsColumns = {
  Image: true,
  Name: true,
  UserType: true,
  UserId: true,
  RFID: true,
  Email: true,
  PhoneNumber: true,
  Status: true,
  Comments: true,
};
// sites 
const sitesColumns = {
  Name: true,
  AreasCount: true,
  KiosksCount: true,
  ReceptionEmail: true,
  Timezone: true,
};

const newSitesColumns = {
  Name: true,
  AreasCount: true,
  KiosksCount: true,
  ReceptionEmail: true,
  Timezone: true,
};
// area 
const areasColumns = {
  Area_Name: true,
  Login_Mode: true,
  Kiosk_Name: true,
  Journey: true,
  Android_Serial: true,
  Lamasatech_Serial: true,
  Mac_Address: true,
  Status: true,
  Pre_Registration_URL:true,
};
// journey
const journeyColumns = {
  Journey_Name: true,
  Flow_Name: true,
  User_Type: true,
  Input: true,
  Checks: true,
  Compliance: true,
  Output: true,
  Notification: true,
  Feedback: true,
};
// export list
const exportListColumns = {
  requested_by: true,
  generation_date: true,
  expiry_date: true,
  type: true,
};
const daemonLogsColumns = {
  id: true,
  kiosk: true,
  type: true,
  status: true,
  requestedAt: true,
  reasonOfFailure: true,
  download: true
}

const emergencyListColumns = {
  image: true,
  fullName: true,
  phone: true,
  userType: true,
  site: true,
  area: true,
  host: true,
  status: true,
  foundBy: true,
  email: true,
  rfid: true,
  user_id: true,
};

const emergencySessionsListColumns = {
  name: true,
  started_by: true,
  started_at: true,
  ended_by: true,
  ended_at: true,
  type: true,
  areas: true,
  actions: true,
};

const emergencySessionListDataColumns = {
  image: true,
  fullName: true,
  phone: true,
  userType: true,
  site: true,
  area: true,
  host: true,
  status: true,
  by: true,
  email: true,
  rfid: true,
  user_id: true,
};


const integrationColumns = {
  integrationName : true,
  integrationType : true,
  status : true,
  syncPeriod : true,
  creationDate : true,
  lastSynced : true,
  createdBy : true,
}

const usersNotOnSiteColumns = {
  fullName: true,
  userType: true,
  company: true,
  email: true,
  phone: true,
  vehicleRegistration: true,
  rfid: true,
  user_id: true,
  user_type_id:true
};

const attendanceModesColumns = {
  name: true,
  type: true,
  integration_name: true,
  working_days: true,
  from: true,
  to: true,
  late_sign_in: true,
  early_sign_out: true,
  duration:true,
};

const announcementsColumns = {
  title: true,
  createdBy: true,
  createdAt: true,
  user_types: true,
  status: true,
  publish_time: true,
  expiry_time: true,
  urgent: true,
  pinned : true,
  editBy : true,
  editAt : true,
};


export {
  entitesColumns,
  dashboardColumns,
  sitesColumns,
  newSitesColumns,
  usersColumns,
  userTypesColumns,
  reportHistoryColumns,
  reportTimeColumns,
  importUsersColumns,
  importQueuesColumns,
  importUsersDetailsColumns,
  complianceColumns,
  areasColumns,
  journeyColumns,
  trackTraceColumns,
  tracAndTraceColumns,
  privacyManagerColumns,
  exportListColumns,
  daemonLogsColumns,
  emergencyListColumns,
  emergencySessionsListColumns,
  emergencySessionListDataColumns,
  integrationColumns,
  usersNotOnSiteColumns,
  attendanceModesColumns,
  announcementsColumns,
};

